import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["duplicateIntervalField"];

  connect() {
    this.toggleDuplicateInterval();
  }

  toggleDuplicateInterval() {
    const selected = this.element.querySelector(
      'input[name="contact_list[exclude_duplicates]"]:checked'
    );
    this.duplicateIntervalFieldTarget.hidden = selected?.value !== "within_this_contact_list";
  }
}
